import { TimeFrame as BaseTimeFrame, TIME_FRAME_CONFIG as BASE_CONFIG } from '../../services/zodiacEngine/AI/Core/AIVariants';

// Challenge-only option; Arena keeps its existing three time tiers.
export const TimeFrame = { ...BaseTimeFrame, TWENTY: 'twenty' } as const;
export type TimeFrame = typeof TimeFrame[keyof typeof TimeFrame];

export const TIME_FRAME_CONFIG = {
  ...BASE_CONFIG,
  [TimeFrame.STANDARD]: { ...BASE_CONFIG[BaseTimeFrame.STANDARD], displayName: 'Medium' },
  [TimeFrame.DEEP]: { ...BASE_CONFIG[BaseTimeFrame.DEEP], displayName: 'Slow' },
  [TimeFrame.TWENTY]: { displayName: 'Deep', timeLimit: 20000, description: 'Extended analysis (20s)' },
};

export function getTimeLimitFromFrame(timeFrame: TimeFrame): number {
  return TIME_FRAME_CONFIG[timeFrame].timeLimit;
}
